import { render, staticRenderFns } from "./changeEventStatis.vue?vue&type=template&id=68866b96&scoped=true&"
import script from "./changeEventStatis.vue?vue&type=script&lang=js&"
export * from "./changeEventStatis.vue?vue&type=script&lang=js&"
import style0 from "./changeEventStatis.vue?vue&type=style&index=0&id=68866b96&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68866b96",
  null
  
)

export default component.exports